import { AppMessageTypeEnum } from '../../modules/shared/enums/app-message-type.enum';

/**
 * Message to be displayed.
 */
export class AppMessage {

    /**
     * Internal counter to generate ids for messages.
     */
    private static counter = 0;

    /**
     * Type - see enum.
     */
    type: AppMessageTypeEnum;

    /**
     * Key to resource bundle.
     */
    message: string;

    /**
     * Id of message.
     */
    id: number;

    static newMessage(type: AppMessageTypeEnum, message: string) {
        return new AppMessage(type, message);
    }

    static newSuccessMessage(message: string) {
        return new AppMessage(AppMessageTypeEnum.SUCCESS, message);
    }

    static newWarningMessage(message: string) {
        return new AppMessage(AppMessageTypeEnum.WARNING, message);
    }

    static newErrorMessage(message: string) {
        return new AppMessage(AppMessageTypeEnum.ERROR, message);
    }

    /**
     * This method is supposed for unit testing only.
     */
    static resetCounter() {
        AppMessage.counter = 0;
    }

    private constructor(type: AppMessageTypeEnum, message: string) {
        this.type = type;
        this.message = message;
        this.id = AppMessage.counter++;
    }

}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/angular-router-loader/src!./~/tslint-loader!./src/app/core/model/app-message.model.ts